<template>
  <section class="bg-degrade">
    <b-container
      class="source-sans shadow rounded mt-0 mt-lg-3 mb-0 mb-lg-5 p-0 p-lg-4 pb-4 bg-white"
    >
      <Banner v-if="mostrarBanner" />
      <b-row v-if="titulo" class="px-lg-0 mb-2 mx-0">
        <b-col cols="12" lg="8">
          <h2
            v-if="titulo"
            class="text-azul-oscuro source-sans mt-3 mt-lg-2 text-center text-lg-left"
          >
            {{ titulo }}
          </h2>
          <div v-if="descripcion" class="text-dark h6">{{ descripcion }}</div>
        </b-col>
        <b-col lg="4" class="d-none d-lg-block text-right">
          <img
            v-if="titulo"
            src="https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/logotop-fondo-blanco.png"
            width="300"
            class="img-fluid"
            alt
          />
        </b-col>
      </b-row>
      <slot></slot>
    </b-container>
  </section>
</template>

<script>
import Banner from "@/components/generales/BannerPostulacion";
export default {
  components: {
    Banner
  },
  //props
  props: {
    titulo: {
      type: String
    },
    descripcion: {
      type: String
    }
  },
  //components
  //data
  data() {
    return {
      mostrarBanner: BANNER_POSTULACION
    };
  }
  //cycle hooks
  //computed props
  //methods
};
</script>



// WEBPACK FOOTER //
// src/components/wrapper/Container.vue